/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import Button from "@mostrans/web-components/components/base/Button";
import {
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import "../../../components/CFIT/style.css";
import { useHistory, useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { globalSuccessAtom } from "../../../shared/globalStates";
import Success from "../../../components/Success";
import { useApolloClient } from "@apollo/client";
import { getCandidateByID } from "../../../graphql/query";
import { isEmpty } from "lodash";
import { handleTimePsikotest } from "./Assesment/handleTimePsikotest";

export default function CFIT() {
  const [showInformation, setShowInformation] = useState(true);
  const [loading, setLoading] = useState(false);
  const success = useRecoilValue(globalSuccessAtom);
  const getSession = localStorage.values;
  const { pathname } = useLocation();
  const splitLocation = pathname.split("/career/mostest-1");
  const history = useHistory();
  const client = useApolloClient();
  const [alreadyTest, setAlreadyTest] = useState(false);
  useEffect(() => {
    setLoading(true);
    if (splitLocation[1] || success) {
      setShowInformation(false);
    } else {
      if (!getSession) {
        setShowInformation(true);
        setLoading(false);
      } else {
        setShowInformation(false);
        history.push("/career/mostest-1/1");
      }
    }
  }, [showInformation, pathname]);

  useEffect(() => {
    setLoading(true);
    getCandidateByID(client).then((response) => {
      const isAssessment = handleTimePsikotest(response.psikotest_date);
      if (!isAssessment) {
        history.push("/career/assessment");
      }
      if (!isEmpty(response.CFIT)) {
        setAlreadyTest(true);
      } else {
        setAlreadyTest(false);
        setLoading(false);
      }
    });
  }, []);

  var title = "Mostest 1";
  var text =
    "You have completed the Mostest 1, we will contact you as soon as possible. ";
  var subtext = "Thank you for your participation. Page will be moved in";

  return (
    <>
      {showInformation && (
        <Information
          setShowInformation={setShowInformation}
          alreadyTest={alreadyTest}
          setLoading={setLoading}
          loading={loading}
        />
      )}
      {success && (
        <Success
          title={title}
          text={text}
          subtext={subtext}
          timer={15000}
          route="ASSESMENT"
          button
        />
      )}
    </>
  );
}

/* <Card>
<CardHeader
  sx={{ textAlign: "center", justifyContent: "center" }}
  title={
    <Box component="div">
      <span
        className={"material-icons text-primary-main"}
        style={{
          fontSize: "50px",
          padding: "10px 0",
        }}>
        info
      </span>
      <p className="font-weight-w600 font-size-h4 text-primary-main">
        Anda sedang mengerjakan Mostest 1, Silahkan lanjutkan
        psikotest anda
      </p>
    </Box>
  }
/>
<CardContent>
  <Box textAlign="center" sx={{ margin: "10px 0" }}>
    <Button variant="contained" color="primary">
      Lanjutkan
    </Button>
  </Box>
</CardContent>
</Card> */

export const Information = ({
  setShowInformation,
  alreadyTest,
  loading,
  setLoading,
}) => {
  const history = useHistory();

  useEffect(() => {
    setLoading(false);
  }, [alreadyTest]);

  const handleClick = () => {
    setLoading(true);
    setShowInformation(false);
    history.push(`/career/mostest-1/1`);
    setLoading(false);
  };

  return (
    <React.Fragment>
      <Card
        className="shadow-soft-s3"
        variant="outlined"
        sx={{ width: "100vh", margin: "auto" }}>
        {loading ? (
          <Box
            sx={{
              textAlign: "center",
            }}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <CardHeader
              sx={{ textAlign: "center", justifyContent: "center" }}
              title={
                <Box component="div">
                  <span
                    className={`material-icons ${
                      alreadyTest ? "text-danger-main" : "text-primary-main"
                    }`}
                    style={{
                      fontSize: "50px",
                      padding: "10px 0",
                    }}>
                    info
                  </span>
                  <p
                    className={`font-weight-w600 font-size-h4 ${
                      alreadyTest ? "text-danger-main" : "text-primary-main"
                    }`}>
                    {alreadyTest
                      ? "Telah selesai mengerjakan Mostest 1"
                      : "Sebelum memulai, perhatikan petunjuk dibawah ini:"}
                  </p>
                </Box>
              }
            />
            <CardContent>
              <Typography
                textAlign="center"
                display={alreadyTest ? "block" : "none"}>
                Maaf kamu tidak diperkenankan untuk mengerjakan test lebih dari
                1 kali.
              </Typography>
              <Typography
                textAlign="center"
                display={alreadyTest ? "block" : "none"}>
                Terjadi kesalahan? Hubungi HR jika terjadi kesalahan.
              </Typography>
              <Box display={alreadyTest ? "none" : "block"}>
                <ol
                  className="font-size-main"
                  style={{
                    listStyleType: "decimal",
                    listStylePosition: "inside",
                    margin: "0 50px ",
                  }}>
                  <li>
                    Pastikan kamu dalam keadaan fokus dan tenang saat
                    mengerjakan Mostest 1.
                  </li>
                  <li>
                    Mostest 1 terdiri dari 4 section soal yang dikerjakan secara
                    berurutan.
                  </li>
                  <li>
                    Terdapat batasan waktu pada setiap section, jadi harap
                    perhatikan waktu yang berjalan.
                  </li>
                  <li>
                    Pengguna harus menyelesaikan satu rangkaian section soal
                    sebelum berpindah atau berganti ke section soal lainnya.
                  </li>
                  <li>
                    Pengguna harap memastikan memiliki koneksi internet yang
                    stabil.
                  </li>
                  <li>
                    Agar pengerjaan lebih nyaman silahkan gunakan, Web Browser
                    Chrome versi terbaru.
                  </li>
                  <li>
                    Jawaban kamu hanya akan tersimpan ke sistem ketika kamu
                    sudah selesai mengerjakan seluruh section soal.
                  </li>
                  <li>
                    Gunakanlah waktu sebaik-baik mungkin, agar tidak terjadi hal
                    yang tidak dinginkan silahkan submit jawaban anda pada 10
                    detik terakhir.
                  </li>
                  <li>
                    Batas waktu pengerjaan untuk section 1 = 3 menit, section 2
                    = 4 menit, section 3 = 3 menit, section 4 = 2.5 menit.
                  </li>
                  <li>
                    Kerjakan tes ini secara mandiri tanpa meminta bantuan dari
                    pihak manapun.
                  </li>
                  <li>
                    Akan diberikan instruksi khusus untuk masing-masing jenis
                    soal, harap perhatikan instruksi dengan baik.
                  </li>
                  <li>
                    Test ini hanya bisa dikerjakan 1 kali saja, disaat kamu
                    sudah mengeklik "Saya mengerti" maka tidak ada toleransi
                    pengulangan test ini, pergunakan test ini sebaik-baiknya.
                  </li>
                  <li>
                    Anda tidak diperkenankan untuk berpindah-pindah section,
                    sistem akan membaca aktifitas anda. Jika diketahui anda
                    melakukan kecurangan maka kami tidak dapat melanjutkan
                    proses lamaran anda.
                  </li>
                </ol>
              </Box>
              <Box textAlign="center" sx={{ margin: "10px 0" }}>
                <Button
                  onClick={() => history.goBack()}
                  variant="contained"
                  color="danger"
                  style={{ marginRight: "25px" }}>
                  Kembali
                </Button>
                <Button
                  onClick={handleClick}
                  variant="contained"
                  color="primary"
                  style={{
                    display: alreadyTest ? "none" : "unset",
                  }}>
                  Saya mengerti
                </Button>
              </Box>
            </CardContent>
          </>
        )}
      </Card>
    </React.Fragment>
  );
};
